// extracted by mini-css-extract-plugin
export default {"placeholder":"social-mentions-pieces-ContentPhoto__placeholder--3A6uD","icon":"social-mentions-pieces-ContentPhoto__icon--2eRLb"};